// extracted by mini-css-extract-plugin
export default {"AdminAddItem":"admin-add-item_AdminAddItem__JAPX1","formRow":"admin-add-item_formRow__6MnUK"};